module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-1-3058773344bee20d0e624aea39bfbc37.svg";